var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bar",style:(_vm.style),attrs:{"draggable":"false"},on:{"click":function($event){return _vm.$emit('click', $event)},"mousedown":function($event){return _vm.$emit('mousedown', $event)}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }